///<reference path="../../../../../typings/index.d.ts"/>
///<reference path="../short-cuts.interfaces.ts"/>
///<reference path="../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="short-cuts-state-manager.controller.ts"/>


module Meevo.Components.ShortCuts {
    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;

    export abstract class MaintenanceShortCutsController<Section extends TSelectedSectionShortCut, T extends TContextShortCut> extends ShortCutsStateManagerController implements IMaintenanceShortCutsController<Section, T> {
        protected abstract context: T;
        protected visualState: Model.MaintenanceFormVisualState;

        protected shortCutGroup: IShortCutGroup | { [key: number]: IShortCutGroup };
        
        private stateName: string;
        private templateName: string;

        get noun() {
            const hasSelectedSection = (<any>this.context || {}).selectedSection || null;

            return !!hasSelectedSection ? this.context.selectedSection.noun : null;
        }

        get mode() {
            return this.context ? (<any>this.context).mode : null;
        }

        constructor(protected $scope: ng.IScope,
                    protected $state: ng.ui.IStateService,
                    protected shortCutsService: IShortCutsService) {
            super($scope, $state, shortCutsService);

            const undeleteGroup = new ShortCutGroup([{
                shortCutName: 'DATA_MAINTENANCE_UNDELETE',
                callback: this.shortCutsService.contextMethodsWrapper<T, IMaintenanceShortCutsController<Section, T>>(this, 'undelete')
            }]);

            this.shortCutGroup = {
                [MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: this.shortCutsService.contextMethodsWrapper<T, IMaintenanceShortCutsController<Section, T>>(this, 'edit')
                }])
            };

            this.stateName = this.$state.current.name;

            const unbind = this.$scope.$watch(() => this.context, (newValue) => {
                if (newValue) {
                    unbind();

                    if (typeof this.context.showDeleteLogic === 'function') {
                        this.shortCutGroup[MaintenanceFormState.Readonly].removeShortCuts([
                            'DATA_MAINTENANCE_DELETE',
                            'DATA_MAINTENANCE_COPY',
                            'DATA_MAINTENANCE_ADD'
                        ]);
                        this.shortCutGroup[MaintenanceFormState.Readonly].addShortCuts([{
                            shortCutName: 'DATA_MAINTENANCE_DELETE',
                            callback: this.shortCutsService.contextMethodsWrapper<T, IMaintenanceShortCutsController<Section, T>>(this, 'delete')
                        }, {
                            shortCutName: 'DATA_MAINTENANCE_COPY',
                            callback: this.shortCutsService.contextMethodsWrapper<T, IMaintenanceShortCutsController<Section, T>>(this, 'copy')
                            }, {
                            shortCutName: 'DATA_MAINTENANCE_ADD',
                            callback: this.shortCutsService.contextMethodsWrapper<T, IMaintenanceShortCutsController<Section, T>>(this, 'add')
                        }]);
                    }

                    this.$scope.$watch(() => this.context.canUndelete, (newValue: boolean, oldValue: boolean) => {
                        if (newValue) {
                            this.shortCutsService.activateGroup(undeleteGroup, this.context.selectedSection.noun);
                        } else if (oldValue) {
                            this.bindHotkeys();
                        }
                    });

                    this.templateName = this.context.selectedSection ? (<any>this.context.selectedSection).template : null;
                    this.$scope.$watch(() => this.context.selectedSection, (newSection: Section) => {
                        const hasSelectedSection = (<any>this.context || {}).selectedSection || null;
                        if (!!hasSelectedSection && newSection.hasOwnProperty('shortCutGroup')) {
                            this.shortCutsService.activateGroup(newSection.shortCutGroup, newSection.noun);
                        } else {
                            this.bindHotkeys();
                        }

                        if (!!hasSelectedSection) {
                            this.templateName = hasSelectedSection.template;
                            this.setAnalyticsTrackingUrl(this.stateName, hasSelectedSection.template);
                        }
                    });

                    const that = this;
                    this.$scope.$root.$on(Components.Common.Messages.ANALYTICS_TRACK_CONTROLLER, (event, args, name) => {
                        if (!name || name !== that.stateName || !that.templateName) return;

                        this.setAnalyticsTrackingUrl(name, that.templateName);
                    });
                }
            });

            this.$scope.$root.$on(Components.Common.Messages.ANALYTICS_CLEAR_SECTION, (event, args, name) => {
                if (!name || name !== this.stateName) return;

                this.stateName = this.templateName = null;
            });
        }

        protected bindHotkeys() {
            if (this.context && this.visualState !== Model.MaintenanceFormVisualState.Search && this.currentModeGroup) {
                this.shortCutsService.activateGroup(this.currentModeGroup, this.noun, false);
            }
        }

        protected unbindHotkeys() {
            this.shortCutsService.deactivateGroup(this.currentModeGroup);
        }

        private setAnalyticsTrackingUrl(name: string, section: string) {
            const pendo = window['pendo'];
            if (!pendo || !pendo.location) return;

            const url = `${window.location.origin}/${name}/${section}`;
            pendo.location.setUrl(url);
            console.log(`PENDO: ${url}`);
        }

        abstract getContext(): T;
    }
}
